import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListController.php
* @route '/api/accounting-code'
*/
const GetAccountingCodeListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingCodeListController.url(options),
    method: 'get',
})

GetAccountingCodeListController.definition = {
    methods: ["get","head"],
    url: '/api/accounting-code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListController.php
* @route '/api/accounting-code'
*/
GetAccountingCodeListController.url = (options?: RouteQueryOptions) => {
    return GetAccountingCodeListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListController.php
* @route '/api/accounting-code'
*/
GetAccountingCodeListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingCodeListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeListController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeListController.php
* @route '/api/accounting-code'
*/
GetAccountingCodeListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAccountingCodeListController.url(options),
    method: 'head',
})

export default GetAccountingCodeListController